import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectService } from 'src/app/data/project/project.service';
import { StringConstants } from 'src/app/constants/string-constants';
import { ToasterService } from 'src/app/api/toaster.service';
import { UserService } from "../../data/user/user.service";
import { Project } from '../../data/models/project';
import { CommonMessages } from 'src/app/constants/common-messages';
import { ProjectsApiService } from 'src/app/api/projects-api.service';
import { Subscription } from 'rxjs';
import { FabricJobStatus } from 'src/app/constants/fabric-workspace-constants';
import { ProjectStatusEnum } from 'src/app/constants/project-status';
import { SyncService } from 'src/app/api/sync.service';

@Component({
    selector: 'app-project-tile',
    templateUrl: './project-tile.component.html',
    styleUrls: ['./project-tile.component.scss'],
    standalone: false
})
export class ProjectTileComponent implements OnInit {
  @Input() project: Project;
  showStatusBadge: boolean;
  isProjectTileAccessible: boolean;
  isProjectAwaitingConfiguration: boolean;
  fabricJobStatus: string;
  subscriptions: Subscription[] = [];
  projectStatusEnum = ProjectStatusEnum;

  constructor(
    private toasterService: ToasterService,
    public projectService: ProjectService,
    public userService: UserService,
    private router: Router,
    public projectApiService: ProjectsApiService,
    public syncService: SyncService
  ) {

  }

  async ngOnInit(): Promise<void> {
    this.showStatusBadge = this.projectService.shouldProjctTileHaveBadge(this.project.status);
    this.isProjectTileAccessible = this.projectService.isProjectAccessible(this.project.status);
    this.isProjectAwaitingConfiguration = this.project.solutionOffering === '';
    //this.checkFabricExecutionStatus();
  }

  navigateToProjectDashboard(): void {

    if (this.isProjectTileAccessible && !this.isProjectAwaitingConfiguration) {
      sessionStorage.setItem("projectName", this.project.projectTitle);
      this.router.navigateByUrl(`project/${this.project.projectId}/project-details`);
    }
    else if (this.isProjectTileAccessible && this.isProjectAwaitingConfiguration) {
      this.toasterService.info(CommonMessages.PROJECT_CONFIGURATION_INCOMPLETE, StringConstants.ERROR);
    }
  }

  checkFabricJobStatus(): void {
    this.subscriptions.push(
      this.projectService.checkProjectFabricJobStatus(this.project.projectId).subscribe({
        next: (response) => {
          this.fabricJobStatus = response;

          if (this.fabricJobStatus === FabricJobStatus.Completed || this.fabricJobStatus === FabricJobStatus.Success) {
            this.toasterService.info(CommonMessages.WORKSPACE_CREATION_COMPLETED, StringConstants.SUCCESS);
            this.project.isFabricJobCompleted = true;
          }
          else if (this.fabricJobStatus === FabricJobStatus.InProgress || this.fabricJobStatus === FabricJobStatus.Running ||
            this.fabricJobStatus === FabricJobStatus.NotStarted)
            this.toasterService.info(CommonMessages.WORKSPACE_CREATION_IN_PROGRESS, StringConstants.SUCCESS);
          else if (this.fabricJobStatus === FabricJobStatus.Failed)
            this.toasterService.info(CommonMessages.WORKSPACE_CREATION_FAILED, StringConstants.ERROR);

          this.syncService.refreshProjectList.next(true);
        }
      })
    );
  }
}
